<template>
  <div class="bar">
    <top-nav />
    <side-bar />
  </div>
</template>

<script>
import TopNav from './topnav.vue';
import SideBar from './sidebar.vue';

export default {
  components: {
    TopNav, SideBar,
  },
  beforeCreate() {
    // 确保刷新的时候有用户数据
    // before的时候 computed 尚不可用
    if (!this.$store.state.Auth.user.ID) {
      this.$store.dispatch('Auth/GetUser');
    }
  },
};
</script>

<style>
.bar {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 1;
}
</style>
